<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <h2 class="white--text text-center">{{ myInfo.site_name }} : {{ myInfo.user_name }}</h2>
        <h6 class="white--text text-center">Logged in at {{ $moment.unix(myInfo.iat).format("HH:mm:ss") }}</h6>
        <!-- ============================================================================================================================ -->
        <div class="my-2 text-right">
            <v-btn @click="getLoginUsers()">現在{{ dbUsers.length }}人ログイン中 <v-icon class="ml-5">mdi-cached</v-icon></v-btn>
        </div>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbDevices" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!-- ---------------------------- -->
                        <v-divider class="my-3"></v-divider>
                        <v-row>
                            <v-col cols="5">
                                <h2 class="ml-5">【 状態 】</h2>
                            </v-col>
                            <v-col>
                                <h4 class="mt-3 text-right">{{ timeFormat(obj.alived_at) }}</h4>
                            </v-col>
                        </v-row>
                        <v-chip class="ma-1" :color="successStatusColor(obj.feederStatus.standby)" text-color="white"><h4>稼働中</h4></v-chip>
                        <v-chip class="ma-1" :color="successStatusColor(obj.feederStatus.oparating || obj.feederStatus.oparating_ai)" text-color="white"><h4>プラン実行中</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_serial)" text-color="white"><h4>シリアル</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_feed_motor)" text-color="white"><h4>モーター1</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_sprinkle_motor)" text-color="white"><h4>モーター2</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_sensor1)" text-color="white"><h4>自発センサー1</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_sensor2)" text-color="white"><h4>自発センサー2</h4></v-chip>
                        <v-chip class="ma-1" :color="errorStatusColor(obj.feederStatus.err_battery_low)" text-color="white"><h4>バッテリー</h4></v-chip>
                        <!-- ---------------------------- -->
                        <div v-show="obj.feeder && obj.feeder.is_stock_sensor">
                            <div class="d-flex align-center mt-3">
                                <h4>飼料残量:&nbsp;&nbsp;</h4>
                                <v-progress-linear style="width: 150px" height="17" :value="obj.feederStatus.stock_level" color="amber darken-4" @dblclick="dispStockAD = !dispStockAD">
                                    <strong v-show="!dispStockAD">{{ obj.feederStatus.stock_level }} % </strong>
                                    <strong v-show="dispStockAD">{{ obj.feederStatus.stock_adval }}</strong>
                                </v-progress-linear>
                            </div>
                        </div>
                        <div v-show="!(obj.feeder && obj.feeder.is_stock_sensor)">
                            <div class="ma-4">&nbsp;</div>
                        </div>
                        <!-- ---------------------------- -->
                        <v-expansion-panels class="mt-5">
                            <v-expansion-panel>
                                <v-expansion-panel-header><h3>（操作、カメラ、解析、情報）</h3></v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-divider class="my-3"></v-divider>
                                    <h2 class="ml-5">【 操作 】</h2>
                                    <v-btn @click="publishMessage(obj.mac, 'standby', 'on')" color="info" v-show="obj.feeder_id" class="ma-2">
                                        <v-icon>mdi-reload</v-icon>
                                        <h4>稼働</h4>
                                    </v-btn>
                                    <v-btn @click="publishMessage(obj.mac, 'standby', 'off')" color="info" v-show="obj.feeder_id" class="ma-2">
                                        <v-icon>mdi-pause</v-icon>
                                        <h4>休止</h4>
                                    </v-btn>
                                    <v-btn @click="publishMessage(obj.mac, 'err', 'reset')" color="info" v-show="obj.feeder_id" class="ma-2">
                                        <v-icon>mdi-check</v-icon>
                                        <h4>エラーリセット</h4>
                                    </v-btn>
                                    <v-btn :to="{ name: 'FeedPlan', params: { device_id: obj.id } }" color="info" v-show="obj.feeder_id" class="ma-2">
                                        <v-icon>mdi-calendar-clock</v-icon>
                                        <h4>給餌プラン</h4>
                                    </v-btn>
                                    <!-- ---------------------------- -->
                                    <v-divider class="my-3"></v-divider>
                                    <h2 class="ml-5">【 カメラ 】</h2>
                                    <div v-show="obj.sd_ver < '20230614'">
                                        <v-btn :to="{ name: 'LiveCam', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera1_id } }" color="info" v-show="obj.camera1_id" class="ma-2">
                                            <v-icon>mdi-camera</v-icon>
                                            <h4>カメラ1</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCam', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera2_id } }" color="info" v-show="obj.camera2_id" class="ma-2">
                                            <v-icon>mdi-camera</v-icon>
                                            <h4>カメラ2</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCam', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera3_id } }" color="info" v-show="obj.camera3_id" class="ma-2">
                                            <v-icon>mdi-camera</v-icon>
                                            <h4>カメラ3</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCam', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera4_id } }" color="info" v-show="obj.camera4_id" class="ma-2">
                                            <v-icon>mdi-camera</v-icon>
                                            <h4>カメラ4</h4>
                                        </v-btn>
                                    </div>
                                    <div v-show="obj.sd_ver >= '20230614'">
                                        <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera1_id } }" color="info" v-show="obj.camera1_id" class="ma-2">
                                            <v-icon>mdi-video</v-icon>
                                            <h4>カメラ1</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera2_id } }" color="info" v-show="obj.camera2_id" class="ma-2">
                                            <v-icon>mdi-video</v-icon>
                                            <h4>カメラ2</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera3_id } }" color="info" v-show="obj.camera3_id" class="ma-2">
                                            <v-icon>mdi-video</v-icon>
                                            <h4>カメラ3</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: obj.id, feeder_id: obj.feeder_id, camera_id: obj.camera4_id } }" color="info" v-show="obj.camera4_id" class="ma-2">
                                            <v-icon>mdi-video</v-icon>
                                            <h4>カメラ4</h4>
                                        </v-btn>
                                        <v-btn :to="{ name: 'LiveAiCam', params: { device_id: obj.id, camera_id: obj.ai_camera_id } }" color="info" v-show="obj.ai_camera_id" class="ma-2">
                                            <v-icon>mdi-camera</v-icon>
                                            <h4>AI カメラ</h4>
                                        </v-btn>
                                    </div>
                                    <!-- ---------------------------- -->
                                    <v-divider class="my-3"></v-divider>
                                    <h2 class="ml-5">【 解析 】</h2>
                                    <v-btn :to="{ name: 'DeviceChart', params: { device_id: obj.id } }" color="info" v-show="obj.feeder_id" class="ma-2">
                                        <v-icon>mdi-chart-bar</v-icon>
                                        <h4>グラフ</h4>
                                    </v-btn>
                                    <!-- ---------------------------- -->
                                    <v-divider class="my-3"></v-divider>
                                    <h2 class="ml-5">【 情報 】</h2>
                                    <h4>本日給餌量：{{ sfsFloatFormat(obj.feederStatus.total_weight) }} kg</h4>
                                    <h4 v-show="obj.feeder && obj.feeder.is_react">本日自発回数：{{ sfsNumberFormat(obj.feederStatus.total_react) }} 回</h4>
                                    <h4 v-show="obj.sensor && obj.sensor.is_water">水温：{{ sfsFloatFormat(obj.feederStatus.water) }} ℃</h4>
                                    <h4 v-show="obj.sensor && obj.sensor.is_temp">気温：{{ sfsFloatFormat(obj.feederStatus.temp) }} ℃</h4>
                                    <h4 v-show="obj.sensor && obj.sensor.is_solar">日射量：{{ sfsFloatFormat(obj.feederStatus.solar) }} W/㎡</h4>
                                    <h4 v-show="obj.sensor && obj.sensor.is_oxygen">溶存酸素：{{ sfsFloatFormat(obj.feederStatus.oxygen) }} mg/L</h4>
                                    <h4 v-show="obj.sensor && obj.sensor.is_salinity">塩分濃度：{{ sfsFloatFormat(obj.feederStatus.salinity) }} ％</h4>
                                    <h4>バッテリー：{{ sfsFloatFormat(obj.feederStatus.battery_volt) }} V</h4>
                                    <!-- ---------------------------- -->
                                    <!--
                                    <div class="d-flex align-center">
                                        <h4>飼料残量:&nbsp;&nbsp;</h4>
                                        <v-progress-linear style="width: 150px" height="17" :value="obj.feederStatus.stock_level" color="amber darken-4">
                                            <strong>{{ obj.feederStatus.stock_level }} %</strong>
                                        </v-progress-linear>
                                    </div>
                                    <v-divider class="my-3"></v-divider>
                                    -->
                                    <!-- ------------------- -->
                                    <v-divider class="my-5"></v-divider>
                                    <v-row>
                                        <v-col>
                                            <h4 class="mt-3" @dblclick="viewCmd = !viewCmd">Ver:{{ obj.feederStatus.version }}</h4>
                                        </v-col>
                                        <v-col>
                                            <h4 class="mt-3 text-right">{{ timeFormat(obj.alived_at) }}</h4>
                                        </v-col>
                                    </v-row>
                                    <!-- ------------------- -->
                                    <v-divider class="my-5"></v-divider>
                                    <v-row v-show="viewCmd">
                                        <v-col>
                                            <div v-for="(obj, index) in obj.feederStatus.cmd" :key="index">
                                                <span>{{ index }}：{{ obj }}</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <!-- ------------------- -->
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
// @ is an alias to /src
import Config from "@/config.json";
import mqtt from "mqtt";
export default {
    name: "DevicesList",
    components: {},
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSite: { id: 0, name: "" },
            dbUsers: [],
            dbDevices: [],
            dbFeeders: [],
            dbSensors: [],
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mac: "ff:ff:ff:ff:ff:ff", //"b8:27:eb:e5:25:c0",
            mqttClient: { connected: false },
            //-----------------------------
            dispStockAD: false,
            //-----------------------------
            isLoading: false,
            viewCmd: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        //非同期でAxiosGet
        this.putUserOperated();
        //const promiseSite = this.getSites();
        const promiseDevices = this.getDevices();
        const promiseFeeders = this.getFeeders();
        const promiseSensors = this.getSensors();
        //-----------------------
        //上記の終了を待つ
        //await promiseSite;
        await promiseDevices;
        await promiseFeeders;
        await promiseSensors;
        //-----------------------
        //上記が全て取得終了したタイミングで、配列マージする
        //await new Promise((r) => setTimeout(r, 500));
        this.mergeDeviceFeederSensor();
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.connectMqtt();
        //-----------------------
        window.scrollTo(0, 0);
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.getLoginUsers();
        //-----------------------
        this.isLoading = false;
    },
    //========================================================
    beforeDestroy: async function () {
        this.disconnectMqtt();
    },
    //========================================================
    methods: {
        //====================================================
        async getSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { id: this.myInfo.site_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSite = response.data.json[0];
            });
        },
        //====================================================
        async getLoginUsers() {
            //------------------------------------------------
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            //------------------------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: {
                    _fields: "id,name",
                    "operated_at[GREAT]": this.$moment().add(-30, "minutes").format("YYYY-MM-DD HH:mm"),
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbUsers = response.data.json;
            });
            //------------------------------------------------
            this.isLoading = false;
            //------------------------------------------------
        },
        //====================================================
        async getDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
                for (let i in this.dbDevices) {
                    this.dbDevices[i]["feederStatus"] = { stock_level: null, stock_adval: null };
                }
            });
        },
        //====================================================
        async getFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                //params: { id: this.feeder_id, },
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeders = response.data.json;
                for (let i in this.dbFeeders) {
                    const otpStr = this.dbFeeders[i]["option_json"];
                    let opt = {};
                    try {
                        opt = JSON.parse(otpStr);
                    } catch {
                        self.console.log("json parse error");
                    }
                    if (opt["stock_sensor"]) {
                        this.dbFeeders[i]["is_stock_sensor"] = true;
                    } else {
                        this.dbFeeders[i]["is_stock_sensor"] = false;
                    }
                }
            });
        },
        //====================================================
        async getSensors() {
            await this.axios({
                method: "GET",
                url: "/web/api/sensors",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensors = response.data.json;
                // for (let i in this.dbSensors) {
                //     this.dbDevices[i]["feederStatus"] = {};
                // }
            });
        },
        //====================================================
        mergeDeviceFeederSensor() {
            for (let i in this.dbDevices) {
                for (let j in this.dbFeeders) {
                    if (this.dbDevices[i]["feeder_id"] == this.dbFeeders[j]["id"]) {
                        this.dbDevices[i]["feeder"] = this.dbFeeders[j];
                        break;
                    }
                }
                //-------------------------------
                for (let j in this.dbSensors) {
                    if (this.dbDevices[i]["sensor_id"] == this.dbSensors[j]["id"]) {
                        this.dbDevices[i]["sensor"] = this.dbSensors[j];
                        break;
                    }
                }
            }
        },
        //====================================================
        chkAlive(alived_at) {
            if (!alived_at) return false;
            let now = this.$moment().add(-2, "hours");
            let alive = this.$moment(alived_at);
            if (now < alive) return false;
            return true;
        },
        //====================================================
        timeFormat(timeStr) {
            let ret = "";
            if (timeStr) ret = this.$moment(timeStr).format("YYYY/M/D HH:mm:ss");
            return ret;
        },
        //====================================================
        async connectMqtt() {
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("MQTT Connected !!");
            });
            //-----------------
            this.mqttClient.on("message", function (topic, message) {
                //gThis.subMessage = message.toString();
                //self.console.log(topic);
                //self.console.log(message.toString());
                let subMsg = message.toString();
                let obj = JSON.parse(subMsg);
                if (obj.type && obj.type == "alive" && obj.feederStatus) {
                    let mac = obj.mac;
                    let alived_at = obj.sent_at; //this.$moment().format("YYYY-MM-DD HH:mm:ss");
                    let feederStatus = obj["feederStatus"];
                    let standby = obj["feederStatus"]["standby"];
                    let err_serial = obj["feederStatus"]["err_serial"];
                    gThis.deviceStatusUpdate(mac, alived_at, feederStatus, standby, err_serial);
                }
            });
            //-----------------
            this.mqttClient.subscribe(this.mqttTopicSub + "/#");
        },
        //====================================================
        deviceStatusUpdate: async function (mac, alived_at, feederStatus, standby, err_serial) {
            for (let i in this.dbDevices) {
                if (mac == this.dbDevices[i]["mac"]) {
                    //-----------------------------------------------------
                    // ラズパイから送信してくる 残量AD値を、パーセントに変換する。
                    let stock_level = 0; //this.dbDevices[i]["feederStatus"]["stock_level"];
                    const stock_high = this.dbDevices[i]["feeder"]["stock_high"];
                    const stock_mid = this.dbDevices[i]["feeder"]["stock_mid"];
                    const stock_low = this.dbDevices[i]["feeder"]["stock_low"];
                    const stock_empty = this.dbDevices[i]["feeder"]["stock_empty"];
                    const ADval = Number(feederStatus.turbidity); //濁度のデータブロックを再利用。残量センサー値
                    if (ADval < stock_empty) stock_level = 25;
                    if (ADval < stock_low) stock_level = 50;
                    if (ADval < stock_mid) stock_level = 75;
                    if (ADval < stock_high) stock_level = 100;
                    if (!ADval) stock_level = null;
                    feederStatus["stock_level"] = stock_level;
                    feederStatus["stock_adval"] = ADval;
                    //-----------------------------------------------------
                    this.$set(this.dbDevices[i], "feederStatus", feederStatus);
                    this.$set(this.dbDevices[i], "alived_at", alived_at);
                    this.$set(this.dbDevices[i], "standby", standby);
                    this.$set(this.dbDevices[i], "err_serial", err_serial);
                    break;
                }
            }
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
        },
        //====================================================
        publishMessage(mac, key, val) {
            const topic = this.mqttTopicPub + "/" + mac;
            const pubMessage = { type: "order", key: key, val: val, mac: mac };
            if (this.mqttClient.connected) {
                this.mqttClient.publish(topic, JSON.stringify(pubMessage));
            }
            this.putUserOperated();
        },
        //====================================================
        successStatusColor(val) {
            if (val == 1) return "green";
            else if (val == 0) return "gray";
            else return "gray";
        },
        //====================================================
        errorStatusColor(val) {
            if (val == 1) return "red";
            else if (val == 0) return "green";
            else return "gray";
        },
        //====================================================
        sfsNumberFormat(val) {
            let ret = "---";
            if (val || val == 0) {
                ret = Number(val);
            }
            return ret;
        },
        //====================================================
        sfsFloatFormat(val) {
            let ret = "---";
            if (val || val == 0) {
                ret = Math.floor(val * 10) / 10;
                ret = ret.toFixed(1);
            }
            return ret;
        },
        //====================================================
        putUserOperated() {
            this.axios({
                method: "PUT",
                url: "/web/api/user_operated",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            });
        },
        //====================================================
    },
};
// alter table feeders add column has_m1sensor int default '0' after sort_no;
// alter table feeders add column has_m2sensor int default '0' after sort_no;
// alter table feeders add column has_loadcell int default '0' after sort_no;
</script>
